{
    "header" : "מערכת ניהול גביה",
    "welcome": "ברוך הבא, ",
    "quickAction" : "פעולות מהירות",
    "addOrder" : "הכנס הזמנה",
    "bigTable" : "טבלה כוללת",
    "customForms" : "טפסים",
    "allActions": "כל הפעולות לפי מחלקות",
    "prayers": "מתפללים",
    "synagogue": "בית כנסת",
    "doners" : "תורמים"
}